/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EditorMenciones as EditorMenciones,
  rec_JSXRuntime as JSXRuntime,
  rec_ListaAdjuntos as ListaAdjuntos,
  rec_Modal as Modal,
  rec_Pr as Pr,
  rec_React as React,
  rec_Ro as Ro,
  rec_api as api,
  rec_ii as ii,
  rec_obtenerUsuario as obtenerUsuario,
  rec_pS as pS,
} from "../../runtime/index.jsx";
export function DetalleHilo({
  id: e,
  proyecto: t,
  onClose: n,
  onCambio: r,
  onCrearTarea: i,
  soloLectura: a,
}) {
  let [o, s] = (0, React.useState)(null),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)([]),
    [p, m] = (0, React.useState)(``),
    h = (0, React.useCallback)(() => {
      api(`/discusiones/${e}`)
        .then(s)
        .catch((e) => m(e.message));
    }, [e]);
  (0, React.useEffect)(() => {
    h();
  }, [h]);
  async function g(t) {
    if ((t.preventDefault(), c.trim()))
      try {
        (await api(`/discusiones/${e}/comentarios`, {
          method: `POST`,
          body: JSON.stringify({
            cuerpo: c,
            autorNombre: obtenerUsuario()?.nombre,
            menciones: u,
          }),
        }),
          l(``),
          f([]),
          h(),
          r());
      } catch (e) {
        m(e.message);
      }
  }
  return (
    <Modal
      titulo={o?.titulo ?? `Hilo`}
      onClose={n}
      ancho={`max-w-xl`}
      children={[
        p && <p className={`text-sm text-(--error)`} children={p} />,
        o ? (
          <div
            className={`flex flex-col gap-3`}
            children={[
              <div
                className={`rounded-2xl bg-(--panel) p-3 text-sm`}
                children={[
                  <p
                    className={`whitespace-pre-wrap text-(--text-h)`}
                    children={o.cuerpo}
                  />,
                  <p
                    className={`mt-1 text-xs text-(--text)`}
                    children={[
                      o.creadoPorNombre || `Alguien`,
                      ` · `,
                      pS(o.creadoEn),
                    ]}
                  />,
                ]}
              />,
              !a && (
                <button
                  type={`button`}
                  onClick={() =>
                    i({
                      discusionOrigenId: o.id,
                      discusionOrigenTitulo: o.titulo,
                    })
                  }
                  className={`flex w-fit items-center gap-1 text-xs font-medium text-(--accent) hover:underline`}
                  children={[
                    <Pr className={`h-3.5 w-3.5`} />,
                    ` Crear tarea a partir de este hilo`,
                  ]}
                />
              ),
              <ul
                className={`flex flex-col gap-2`}
                children={o.comentarios?.map((e) => (
                  <li
                    key={e.id}
                    className={`rounded-2xl border border-(--border) p-3 text-sm`}
                    children={[
                      <p
                        className={`whitespace-pre-wrap text-(--text-h)`}
                        children={e.cuerpo}
                      />,
                      <p
                        className={`mt-1 text-xs text-(--text)`}
                        children={[
                          e.autorNombre || `Alguien`,
                          ` · `,
                          pS(e.creadoEn),
                        ]}
                      />,
                    ]}
                  />
                ))}
              />,
              <ListaAdjuntos
                entidadTipo={`DISCUSION`}
                entidadId={o.id}
                soloLectura={a}
              />,
              !a && !o.cerrada && (
                <form
                  onSubmit={g}
                  className={`flex flex-col gap-2`}
                  children={[
                    <EditorMenciones
                      value={c}
                      onChange={l}
                      onMenciones={f}
                      miembros={t.miembros ?? []}
                      rows={2}
                      placeholder={`Responder — @ para mencionar`}
                      className={`w-full rounded-2xl border border-(--border) bg-(--bg) px-3 py-2 text-sm text-(--text-h) outline-none transition duration-150 ease-(--curva) focus:border-(--accent-border) focus:ring-2 focus:ring-(--accent-bg) min-h-16`}
                    />,
                    <div
                      className={`flex justify-end`}
                      children={
                        <button
                          type={`submit`}
                          className={Ro}
                          children={`Responder`}
                        />
                      }
                    />,
                  ]}
                />
              ),
            ]}
          />
        ) : (
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          })
        ),
      ]}
    />
  );
}
